var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-wrapper"},[_c('button',{staticClass:"back-to-home",on:{"click":_vm.navLanding}},[_vm._v("Terug naar waar je was")])])}
var staticRenderFns = []

export { render, staticRenderFns }